const INIT_STATE = {
   currentBoard: {
      sheets: [],
   },
   boards: [],
   sheet: "",
   role: "",
   listOfWidgetsId: [],
   clickedRow: null,
   stateChange: false,
   boardColumns: 3,
};
// TODO: I'm not 100% sure what's the goal of this function and it seems like the reducer it's used in is not used anywhere (it is but the condition it depends on is never fulfilled) so I left it as it was, just changed so it doesnt mutate state. As for stateChange parameter - I only left it where it was originally because I don't know where it should be used.
const mapOrder = (array, order, key) => {
   const noMutation = array.map((item) => item);
   noMutation.sort((a, b) => {
      let A = a[key];
      let B = b[key];
      if (order.indexOf(A.toString()) > order.indexOf(B.toString())) {
         return 1;
      } else {
         return -1;
      }
   });
   array.map((item) => (item.priority = noMutation.indexOf(item)));
   return array;
};
export default (state = INIT_STATE, action) => {
   switch (action.type) {
      case "SET_BOARD": {
         return {
            ...state,
            currentBoard: action.payload,
         };
      }
      case "CHANGE_TABS_ORDER": {
         const orderedSheets = mapOrder(state.currentBoard.sheets, action.payload, "id");
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: orderedSheets,
            },
         };
      }
      case "SET_SHEET": {
         return {
            ...state,
            sheet: action.payload,
         };
      }
      case "ADD_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: [...state.currentBoard.sheets, action.payload],
            },
            stateChange: !state.stateChange,
         };
      }
      case "EDIT_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === action.payload.id) {
                     return {
                        ...sheet,
                        name: action.payload.name,
                        iconFileId: action.payload.iconFileId,
                        iconFileName: action.payload.iconFileName,
                        url: action.payload.url,
                        redirect: action.payload.redirect,
                        mobileView: action.payload.mobileView,
                        isMobileOnly: action.payload.isMobileOnly,
                     };
                  }
                  return sheet;
               }),
            },
            stateChange: !state.stateChange,
         };
      }
      case "SET_ALL_SHEETS": {
         const currentSheets = Array.isArray(state?.currentBoard?.sheets)
            ? state.currentBoard.sheets
            : [];

         const payloadSheets = Array.isArray(action.payload) ? action.payload : [];

         let newTabSheets = [...currentSheets];

         payloadSheets.forEach((sheet) => {
            const index = newTabSheets.findIndex((item) => item.id === sheet.id);

            if (index !== -1) {
               newTabSheets[index] = {
                  ...newTabSheets[index],
                  name: sheet.name,
                  iconFileId: sheet.iconFileId,
                  iconFileName: sheet.iconFileName,
                  url: sheet.url,
                  redirect: sheet.redirect,
                  mobileView: sheet.mobileView,
                  isMobileOnly: sheet.isMobileOnly,
               };
            } else {
               newTabSheets.push(sheet);
            }
         });

         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: newTabSheets,
            },
            stateChange: !state.stateChange,
         };
      }

      case "DELETE_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.filter((sheet) => sheet.id !== action.payload.id),
            },
         };
      }
      case "EDIT_BACKGROUND_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               backgroundColourHex: action.payload,
            },
         };
      }
      case "EDIT_TABS_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               tabsAreBottomOnMobile: action.payload,
            },
         };
      }
      case "SET_BOARD_ROLE": {
         return {
            ...state,
            role: action.payload,
         };
      }
      case "ADD_WIDGET_IN_SHEET": {
         const priorities = [];
         state.currentBoard.sheets?.map((sheet) => {
            if (sheet.id == state.sheet)
               return sheet.widgets.map((widget) => priorities.push(widget.priority));
         });
         const lastNumber = Math.max(...priorities);
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets?.map((sheet) => {
                  if (sheet.id == state.sheet) {
                     return {
                        ...sheet,
                        widgets: [
                           ...sheet.widgets,
                           {
                              ...action.payload,
                              priority: lastNumber + 1,
                           },
                        ],
                     };
                  }
                  return sheet;
               }),
            },
         };
      }
      case "CHANGE_WIDGETS_ORDER": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id !== state.sheet) return sheet;
                  return {
                     ...sheet,
                     widgets: action.payload,
                  };
               }),
            },
         };
      }
      case "DELETE_WIDGET_IN_SHEET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === state.sheet) {
                     return {
                        ...sheet,
                        widgets: sheet.widgets.filter((widget) => {
                           return widget.id !== action.payload;
                        }),
                     };
                  }
                  return sheet;
               }),
            },
         };
      }
      case "SET_WIDGET_IN_SHEET_PARAMS": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === state.sheet) {
                     return {
                        ...sheet,
                        widgets: sheet.widgets.map((widget) => {
                           if (widget.id === action.payload.id)
                              return {
                                 ...action.payload,
                              };
                           return widget;
                        }),
                     };
                  }
                  return sheet;
               }),
               checked: Math.random(),
            },
         };
      }
      case "SET_CLICKED_ROW": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === state.sheet)
                     return {
                        ...sheet,
                        widgets: sheet.widgets.map((widget) => {
                           if (widget.id === action.payload.id)
                              return {
                                 ...widget,
                                 clickedRow: action.payload.clickedRow.id,
                              };
                           return widget;
                        }),
                     };
                  return sheet;
               }),
            },
            clickedRow: {
               row: action.payload.clickedRow.id,
               widget: action.payload.id.toString(),
            },
         };
      }
      case "SET_PROPERTY_IN_WIDGET": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === state.sheet) {
                     return {
                        ...sheet,
                        widgets: sheet.widgets.map((widget) => {
                           if (widget.id === action.payload.id)
                              return {
                                 ...widget,
                                 [action.payload.propertyName]: action.payload.value,
                              };
                           else return widget;
                        }),
                     };
                  } else return sheet;
               }),
            },
         };
      }
      case "SET_DATE_START": {
         return {
            ...state,
            currentBoard: {
               ...state.currentBoard,
               sheets: state.currentBoard.sheets.map((sheet) => {
                  if (sheet.id === state.sheet)
                     return {
                        ...sheet,
                        widgets: sheet.widgets.map((widget) => {
                           if (widget.id === action.payload.id)
                              return {
                                 ...widget,
                                 dateStart: action.payload.dateStart,
                              };
                           return widget;
                        }),
                     };
                  return sheet;
               }),
            },
         };
      }
      case "SET_BOARD_COLUMNS": {
         return {
            ...state,
            boardColumns: action.payload,
         };
      }
      case "SET_USER_BOARDS": {
         // Check if any existing boards have iconLinks and new boards don't
         const hasExistingIcons = state.boards.some((board) => board.iconLink);
         const hasNewIcons = action.payload.some((board) => board.iconLink);

         let preservedBoards = action.payload;

         // If existing boards have icons but new boards don't, preserve all existing icons
         if (hasExistingIcons && !hasNewIcons) {
            preservedBoards = action.payload.map((newBoard) => {
               const existingBoard = state.boards.find((board) => board.id === newBoard.id);
               return {
                  ...newBoard,
                  ...(existingBoard?.iconLink && { iconLink: existingBoard.iconLink }),
               };
            });
         }

         return {
            ...state,
            boards: preservedBoards,
         };
      }
      default:
         return state;
   }
};
